/**
 * Single source of truth for the church's contact details.
 * Used by the header, footer, contact page, and structured data.
 */
export const church = {
  name: 'Metropolitan Church of God',
  shortName: 'Metropolitan',

  address: {
    street: '13400 Schaefer Highway',
    city: 'Detroit',
    state: 'MI',
    zip: '48227',
  },

  // Used for the "Get directions" link and the map embed.
  mapQuery: '13400 Schaefer Highway, Detroit, MI 48227',

  email: 'info@mcogdetroit.org',
  officeEmail: 'office@mcogdetroit.org',

  phone: '313.273.5580',
  phoneHref: 'tel:+13132735580',

  services: [
    { label: 'Sunday School', time: '8:30 AM' },
    { label: 'Sunday Worship', time: '9:45 – 11:00 AM' },
  ],

  // Zoom bridge used for Education Institute classes.
  zoom: {
    url: 'https://zoom.us/j/3132735580',
    meetingId: '313-273-5580',
    dialIn: '(646) 558-8656',
  },

  social: [
    { name: 'Facebook', href: 'https://facebook.com/metrocog' },
    { name: 'Twitter', href: 'https://twitter.com/metrocog' },
    { name: 'Instagram', href: 'https://instagram.com/metrocog' },
    { name: 'YouTube', href: 'https://youtube.com/metropolitancog' },
  ],
};

export const formattedAddress = `${church.address.street}, ${church.address.city}, ${church.address.state} ${church.address.zip}`;
